import { api } from './api';

const source = (() => {
  if (new URLSearchParams(window.location.search).get('from') === 'blog') return 'blog';
  if (!document.referrer) return 'direct';
  try { return new URL(document.referrer).hostname === 'aaron.com.es' ? 'blog' : 'other'; }
  catch { return 'other'; }
})();

export function count(event) {
  api('/event', { event, source }).catch(() => {});
}
